import { QrPanel, type QrPanelProps } from '@akpl/ui-tv';

import { useJoinQr } from '../queue/useJoinQr';
import { useStore } from '../store';
import { useT } from '../useT';

/**
 * "Busca desde tu celular": the one QR + instructions block of the TV (owner 2026-10-05), on
 * Search under the keyboard, at the bottom of Home and at the foot of the expanded rail. The
 * URL is the session's join URL (`GET /sessions/:sid/qr`, else built from the join code), so a
 * phone that scans it lands in this room ready to search and send songs.
 *
 * `compact` drops the title and uses the short instruction, for the rail's 382 px column.
 * Never focusable (it is a `QrPanel`).
 */
export function PhoneQr({
  compact = false,
  size,
  className,
  'data-testid': testId,
}: {
  compact?: boolean;
  size?: number;
  className?: string;
  'data-testid'?: string;
}) {
  const { t } = useT();
  const sid = useStore((s) => s.session?.id ?? null);
  const joinCode = useStore((s) => s.session?.joinCode ?? s.meta?.joinCode ?? null);
  const joinUrl = useJoinQr(sid, joinCode);
  const props: QrPanelProps = compact
    ? { value: joinUrl, body: t('tv:join.homeHint'), size: size ?? 180, tone: 'bare' }
    : {
        value: joinUrl,
        title: t('tv:search.fromPhone'),
        body: t('tv:search.scanToSearch'),
        size: size ?? 200,
      };
  return <QrPanel {...props} className={className} data-testid={testId} />;
}
